import { render, staticRenderFns } from "./AmpUpload.vue?vue&type=template&id=0411063c"
import script from "./AmpUpload.vue?vue&type=script&lang=js"
export * from "./AmpUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports